module.exports = __webpack_public_path__ + "static/img/Tablet_Banner.5a3d435.jpg";